/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WarningCauseEnum {
    WARNING = 'WARNING',
    SUSPENSION_YELLOW = 'SUSPENSION_YELLOW',
    SUSPENSION_RED = 'SUSPENSION_RED',
}
